import { useEffect, useState } from "react";
import { Spinner } from "./Spinner";

// Narrated wait for the photorealistic blend — the LONGEST wait in the flow (20–60s of engine +
// judge round-trips) previously showed one static spinner line. The blend is a single long POST
// (no stage telemetry to poll, unlike extraction), so the narration is time-driven: staged copy
// that mirrors what the pipeline genuinely does, over an asymptotic progress bar that always moves
// but never lies about being done. Fits the preview card's fixed 48px CTA slot (anti-jitter).
const STAGES = [
  "Studying your home's lighting…",
  "Blending the door into the scene…",
  "Matching shadows and reflections…",
  "Double-checking the details…",
];
const STAGE_SECONDS = 6;

export function BlendWait() {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    const t0 = performance.now();
    const id = setInterval(() => setElapsed((performance.now() - t0) / 1000), 1000);
    return () => clearInterval(id);
  }, []);

  const stage = Math.min(STAGES.length - 1, Math.floor(elapsed / STAGE_SECONDS));
  // 1 - e^(-t/22): ~24% at 6s, ~60% at 20s, ~93% at 60s — visibly alive, never a false 100%.
  const pct = Math.min(95, Math.round(100 * (1 - Math.exp(-elapsed / 22))));

  return (
    <div data-testid="blend-wait" style={{ display: "flex", flexDirection: "column", gap: 7 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, color: "var(--brand-active)", fontSize: 13, fontWeight: 600 }}>
        <Spinner size={14} />
        <span aria-live="polite">{STAGES[stage]}</span>
      </div>
      <div style={{ height: 3, borderRadius: 2, background: "var(--brand-tint)", overflow: "hidden" }} aria-hidden="true">
        <div style={{ height: "100%", width: `${pct}%`, background: "var(--brand)", borderRadius: 2, transition: "width 900ms linear" }} />
      </div>
    </div>
  );
}
